import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./index.css";
import "./fonts.css";

import { Provider } from "react-redux";
import store from "./material-app-pro/src/redux/store/index";

import serviceWorkerRegistration from './domain/services/service.worker.service'; 

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("root")
);

serviceWorkerRegistration.register();